import { Box, Select } from '@robocorp/components';
import { FC, useCallback, useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useIndexedProcessRunsQuery } from '~/queries';
import { VariablesContext } from '../context';

interface Props {
  workspaceId: string;
}

export const SelectProcessRun: FC<Props> = ({ workspaceId }) => {
  const { endpoint, variables, setVariables } = useContext(VariablesContext);
  const { t } = useTranslation();

  const {
    refetch,
    data: indexedProcessRuns,
    isLoading: isLoadingProcessRuns,
  } = useIndexedProcessRunsQuery({
    processId: variables.processId,
    workspaceId,
    size: 30,
    options: {
      enabled: false,
    },
  });

  useEffect(() => {
    if (!variables.processId) return;
    refetch();
  }, [variables.processId, refetch]);

  const processRunItems = useMemo(() => {
    return indexedProcessRuns?.processRuns
      ? indexedProcessRuns.processRuns.map(({ id, processName, runNo }) => {
          return { label: `${processName} #${runNo}`, value: id };
        })
      : [];
  }, [indexedProcessRuns]);

  const onChange = useCallback(
    (processRunId: string) => {
      setVariables({ processRunId, robotRunId: undefined });
    },
    [setVariables],
  );

  let placeholder = processRunItems.length ? `${t('choose')}...` : t('noRunsForProcess');
  if (isLoadingProcessRuns) {
    placeholder = t('loading');
  }

  return !endpoint.includes('processRunId') ? null : (
    <Box mb={20}>
      <Select
        label={t('chooseProcessRun')}
        items={processRunItems}
        onChange={onChange}
        disabled={isLoadingProcessRuns || !variables.processId || !indexedProcessRuns?.processRuns}
        value={variables.processRunId}
        placeholder={placeholder}
      />
    </Box>
  );
};
